import React from 'react';

import { useStyles } from '~/assets/styles';
import useClaimActiveTab from '~/components/ClaimPage/hooks/useClaimActiveTab';
import type { ClaimSideBarTab, SideBarKey } from '~/components/ClaimPage/hooks/useClaimSideBarTabs/utils';

import { ClaimSidebarTab } from '../ClaimSidebarTab';

interface ClaimSidebarProps {
  tabs: ClaimSideBarTab<SideBarKey>[];
  location: {
    pathname: string;
  };
  match: {
    path: string;
    url: string;
  };
  claim: {
    id: number;
  };
  reloadLegalActions: () => Promise<void>;
}

export const ClaimSidebar: React.FC<ClaimSidebarProps> = ({ tabs, match, claim, reloadLegalActions }) => {
  const { classes } = useStyles();
  const { activeTab } = useClaimActiveTab();

  return (
    <div className={classes.claimMenu}>
      {tabs.map((tab, idx) => {
        const isActive = tab.url === activeTab?.url;

        return (
          <div key={idx} className={classes.claimMenuButtonContainer}>
            <ClaimSidebarTab
              label={tab.label}
              IconComponent={tab.IconComponent}
              IconProps={tab.IconProps}
              url={tab.url}
              permissions={tab.permissions}
              LabelComponent={tab.LabelComponent}
              labelComponentProps={tab.labelComponentProps}
              shouldReloadLegalActions={tab.shouldReloadLegalActions}
              isActive={isActive}
              match={match}
              claim={claim}
              reloadLegalActions={reloadLegalActions}
            />
          </div>
        );
      })}
    </div>
  );
};
